import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import RichTable from '../components/richTable/RichTable.jsx'
import TableHelpers from '../helpers/TableHelpers.js';

function SingleAlgoCorrelations(props) {
    const [data, setData] = useState([]);
    const [filterTradeSymbol, setFilterTradeSymbol] = useState(true);
    const [filterAlgoType, setFilterAlgoType] = useState(true);
    const [allocations, setAllocations] = useState([]);

    useEffect(() => {
        (async function () {
            const url = `/api/algoCorrelation?algoId=` + props.algoId
            let d = await (await fetch(url)).json();
            console.log("correlations", d)
            setData(d);

            let allocationsText = await (await fetch(`/api/algos?planId=` + props.planId + `&years=5`)).json();
            console.log("allocations", allocationsText);
            setAllocations(allocationsText);
        })();
    }, [props.algoId, props.planId]);

    function algoLinkFormatter(cell, row) {
        return <Link reloadDocument to={"/algo/" + row.secondary_algoId}>{cell}</Link>;
    }

    function getCorrelations() {
        return data
            .filter(algo => filterTradeSymbol ? algo.secondary_trade_symbol === props.symbol : true)
            .filter(algo => filterAlgoType ? algo.secondary_algo_type === props.algoType : true)
            .map(algo => {
                let allocation = allocations.find(a => a.algoId === algo.secondary_algoId)
                return {
                    allocation: allocation ? allocation.percentage : null,
                    sum: algo.percent + algo.secondary_percent,
                    ...algo
                }
            })
    }


    return (
        <>

            <center>
                <input type="checkbox" checked={filterTradeSymbol} onChange={() => setFilterTradeSymbol(!filterTradeSymbol)} /> Filter by trade symbol
                <br></br>
                <input type="checkbox" checked={filterAlgoType} onChange={() => setFilterAlgoType(!filterAlgoType)} /> Filter by algo type
            </center>

            <RichTable data={getCorrelations()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algo', field: 'secondary_display_name', formatter: algoLinkFormatter, filter: 'text' },
                { title: 'Symbol', field: 'secondary_symbol', sorters: true, filter: 'choice' },
                { title: 'Trade Symbol', field: 'secondary_trade_symbol', sorters: true, filter: 'choice' },
                { title: 'Type', field: 'secondary_algo_type', sorters: true, filter: 'choice' },
                { title: 'Correlation', field: 'percent', sorters: true, isDefaultSort: true },
                { title: 'Reverse', field: 'secondary_percent', sorters: true, isDefaultSort: true },
                { title: 'Sum', field: 'sum', sorters: true, isDefaultSort: true },
                { title: 'Allocation', field: 'allocation', sorters: true, formmatter: TableHelpers.percentFormatterNoDecimals },
            ]} />

        </>
    );
}

export default SingleAlgoCorrelations;